module.exports = __webpack_public_path__ + "img/arrow-down-to-line.879bf4ab.svg";